import { useMemo } from "react";

import { PolicyType } from "types/generated";
import { AVAILABLE_POLICY_TYPES } from "constants/policy";
import useIntentProjectAccess from "shared/IntentProject/useIntentProjectAccess";

/**
 * Hook that returns available policy types, including feature-flagged types.
 * Currently adds PolicyType.Intent when squirrelIntentProject feature flag is enabled.
 * TODO: add PolicyType.Intent directly to AVAILABLE_POLICY_TYPES when squirrelIntentProject feature flag is removed
 */
const useAvailablePolicyTypes = (): PolicyType[] => {
  const hasIntentProjectAccess = useIntentProjectAccess();

  const hasIntentPolicyType = hasIntentProjectAccess;

  return useMemo(() => {
    const policyTypes: PolicyType[] = [...AVAILABLE_POLICY_TYPES];

    // Add Intent policy type if feature flag is enabled
    if (hasIntentPolicyType) {
      policyTypes.push(PolicyType.Intent);
    }

    return policyTypes;
  }, [hasIntentPolicyType]);
};

export default useAvailablePolicyTypes;
